// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"620a12a0","703":"777fbb9d"}[chunkId] + ".chunk.js";
};